module.exports = __webpack_public_path__ + "static/media/Marotte_Chene_aurea_MT2-22-Scale.9fe52f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Chene_aurea_MT2-22-Scale.jpg
// module id = 952
// module chunks = 37